import React from 'react';
import { MapPin, Mail, Briefcase, Building2 } from 'lucide-react';
import ServiceCTA from '../components/ServiceCTA';
import TrustBadge from '../components/TrustBadge';

const Company = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 fade-in">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              会社概要
            </h1>
            <p className="text-xl text-gray-700">
              地域のお店に寄り添うデジタルパートナー
            </p>
          </div>

          {/* Company Info */}
          <div className="max-w-4xl mx-auto">
            {/* About SLBS */}
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-12">
              <TrustBadge className="mb-6" />
              <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                SLBSについて
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Sakura Local Business Support（SLBS）は、さくらグローバル合同会社が運営する地域事業者・クリエイター支援事業です。
              </p>
              <p className="text-gray-700 leading-relaxed">
                私たちは、地域企業・個人事業主・クリエイターの皆様がデジタルの力を活用し、新たな顧客とのつながりや販路拡大を実現できるよう、SNS運用、ライブ配信、デジタルマーケティング、クリエイター支援など幅広いサービスを提供しています。
              </p>
            </div>

            {/* Mission Statement */}
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-12">
              <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                ミッション
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                地域の小さなお店やクリエイターが、デジタルを無理なく活用できる未来をつくる
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-12">
              <h2 className="text-2xl font-bold mb-8" style={{ color: '#2C2C2C' }}>
                会社情報
              </h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <Briefcase className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>事業名</h3>
                    <p className="text-gray-700">さくらローカルビジネスサポート（SLBS）</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Building2 className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>運営会社</h3>
                    <p className="text-gray-700">さくらグローバル合同会社（Sakura Global LLC）</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>所在地</h3>
                    <p className="text-gray-700">兵庫県赤穂郡上郡町</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Briefcase className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>認定</h3>
                    <p className="text-gray-700">TikTok LIVE公認エージェンシー</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Briefcase className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>設立</h3>
                    <p className="text-gray-700">2025年</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>対応エリア</h3>
                    <p className="text-gray-700">上郡町・赤穂市・たつの市・相生市</p>
                    <p className="text-xs text-gray-500 mt-1">※ Webサイト制作・ホスティングのみの場合は、SNS経由で全国対応しています。</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail className="w-6 h-6 mt-1 mr-4 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                  <div>
                    <h3 className="font-semibold mb-1" style={{ color: '#2C2C2C' }}>お問い合わせ</h3>
                    <p className="text-gray-700">info@sakura-local.jp</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Business Content */}
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <h2 className="text-2xl font-bold mb-8" style={{ color: '#2C2C2C' }}>
                事業内容
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="font-semibold mb-2" style={{ color: '#2C2C2C' }}>Webサイト制作</h3>
                  <p className="text-sm text-gray-600">スマホ対応のホームページ制作・デザイン</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="font-semibold mb-2" style={{ color: '#2C2C2C' }}>SNS運用サポート</h3>
                  <p className="text-sm text-gray-600">Instagram・Facebookの投稿代行・運用</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="font-semibold mb-2" style={{ color: '#2C2C2C' }}>TikTok LIVE・ライブ配信サポート</h3>
                  <p className="text-sm text-gray-600">TikTok LIVEを活用した集客・商品PR・地域プロモーション</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="font-semibold mb-2" style={{ color: '#2C2C2C' }}>MEO対策</h3>
                  <p className="text-sm text-gray-600">Googleマップ最適化・口コミ対応</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="font-semibold mb-2" style={{ color: '#2C2C2C' }}>ビジネスコンサルティング</h3>
                  <p className="text-sm text-gray-600">売上改善・店舗運営相談</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <ServiceCTA 
        title="お気軽にご相談ください"
        description="無料でお話をお伺いいたします。"
        buttonText="無料相談はこちら"
      />
    </div>
  );
};

export default Company;